import React, { Component } from 'react';

class HighlightArea extends Component {
  shouldComponentUpdate(nextProps) {
    if ((nextProps.active !== this.props.active) || (nextProps.width !== this.props.width)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <g transform={`translate(0,${this.props.y})`}>
        <rect
          className="income-layer"
          x="0"
          y="0"
          height={this.props.height}
          width={this.props.width}
          fill={this.props.active ? '#d4dde5' : '#fff'}
          onMouseEnter={e => this.props.onMouseEnter(e, this.props.layer)}
          onMouseMove={e => this.props.onMouseMove(e)}
          onMouseLeave={e => this.props.onMouseLeave(e)}
        />
      </g>
    );
  }
}

export default HighlightArea;



// WEBPACK FOOTER //
// ./src/components/BarChart/HighLightArea.js